/**
 * OrgAdminSetupGuard — setup wizard is now optional (guided tour, not a blocker).
 * Admins land on /org directly; they can start the welcome wizard from there if they want.
 */
export default function OrgAdminSetupGuard({ children }: { children: JSX.Element }) {
  return children;
}
